module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }